'use strict';

// Using ids instead of names as the usnat api does not provide vendor names
const vendorIds = {
	googleAdvertisingProducts: '5f1aada6b8e05c306c0597d7',
	covatic: '622b1a2a293cdf2be28075f2',
	permutive: '5f369a02b8e05c2f2d546a40',
	bauerMediaGroup: '5f8036e6145f6b2baf93e3d6'
};

module.exports = {
	vendorIds: vendorIds
};